<script setup lang="ts">
import MainIcon from "~icons/mdi/ethernet";
import type { LANParam } from "../../common/types.common";
import { defineActions, defineState } from "../common";
import { FormInputSelect, FormInputText } from "../input";
import { FormMessage, FormPanel, FormTool } from "../internal";
import { type BaseProps, defaultProps } from "../props";

interface OptionType {
    label: string;
    value: string;
}

type ModelType = LANParam;
interface PropsType extends BaseProps<ModelType> {
    wanOptions: OptionType[];
    placeholder?: {
        [K in keyof ModelType]: string;
    };
}

const props = withDefaults(defineProps<PropsType>(), {
    ...defaultProps<ModelType>(),
    value: undefined,
});

const model = defineModel<ModelType>({
    required: true,
});

const state = defineState({
    model: model,
    props: props,
    hasValue: () => {
        return true;
    },
});

const actions = defineActions(model, props, state);
</script>

<template>
    <FormPanel :param="props">
        <template #header>
            <span class="inline-flex flex-row items-center gap-3">
                <MainIcon class="ml-1" />
                <span class="font-semibold text-gray-600 inline-flex flex-row gap-4 items-center">
                    {{ props.label }}
                </span>
            </span>
        </template>

        <template #icons>
            <span class="inline-flex flex-row gap-2">
                <FormTool :actions="actions" :param="props" :showUpdate="true" :state="state" />
            </span>
        </template>

        <div v-if="state.hasError" class="p-4">
            <FormMessage :state="state" />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
            <FormInputText v-model="model.status" embedMode="embed" label="Status" mode="static" />
            <FormInputSelect
                v-model="model.wanBinding"
                embedMode="embed"
                label="WAN Binding"
                :mode="state.nestMode"
                :options="props.wanOptions"
            />
        </div>
    </FormPanel>
</template>
